import HTMLElement from '../html-element/HTMLElement.js';
/**
 * HTMLTableCaptionElement
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/HTMLTableCaptionElement
 */
export default class HTMLTableCaptionElement extends HTMLElement {}
